/* Scentedelic · light mode switch
   Dark is the default. A switch stores the choice in localStorage ("sd-mode") and toggles
   html.sd-light; layout/theme.liquid holds the light palette for product, collection, search
   and collection-list pages and for the menu drawer, and applies the stored choice before the
   first paint. The page cross-fades where the browser supports view transitions. */
(function () {
  var KEY = 'sd-mode';
  var root = document.documentElement;
  var busy = false;
  var NAMES = {
    dark: ['Dark mode, switch to light mode', 'Switch to light mode'],
    light: ['Light mode, switch to dark mode', 'Switch to dark mode']
  };

  function isLight() {
    return root.classList.contains('sd-light');
  }

  function stored() {
    try { return localStorage.getItem(KEY) === 'light'; } catch (e) { return false; }
  }

  function store(light) {
    try { localStorage.setItem(KEY, light ? 'light' : 'dark'); } catch (e) {}
  }

  function sync() {
    var name = NAMES[isLight() ? 'light' : 'dark'];
    document.querySelectorAll('[data-sd-mode-toggle]').forEach(function (b) {
      b.setAttribute('aria-label', name[0]);
      if (b.hasAttribute('title')) b.setAttribute('title', name[1]);
    });
  }

  function apply(light) {
    root.classList.toggle('sd-light', light);
    sync();
  }

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function fade(light) {
    busy = true;
    root.classList.add('sd-vt');
    var vt;
    try {
      vt = document.startViewTransition(function () { apply(light); });
    } catch (e) {
      end();
      apply(light);
      return;
    }
    vt.ready.catch(function () {});
    vt.finished.then(end, end);
    function end() {
      root.classList.remove('sd-vt');
      busy = false;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sd-mode-toggle]') : null;
    if (!btn) return;
    e.preventDefault();

    var light = !isLight();
    store(light);

    if (!busy && !reduced() && typeof document.startViewTransition === 'function') {
      fade(light);
    } else {
      apply(light);
    }
  });

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) apply(e.newValue === 'light');
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) apply(stored());
  });

  document.addEventListener('shopify:section:load', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
